module.exports = __webpack_public_path__ + "img/开.172f3f13.png";